export default __webpack_public_path__ + "static/media/0169.1ab6d3ff.png";